/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Beds = {
    type: 'array',
    contains: {
        type: 'Bed',
    },
};